<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">{{ $t("Gestores do Sistema") }}</h1>

        <b-card class="shadow">
            <div class="list-users-component">
                <div class="row">
                    <div class="col-12">
                        <div
                            class="d-flex align-items-center justify-content-between mb-4"
                        >
                            <router-link
                                class="btn btn-primary"
                                to="/dashboard/admin/users/add"
                            >
                                <i class="fas fa-plus-square" />
                                {{ $t("Cadastrar") }}
                            </router-link>

                            <div>
                                <div class="input-group mb-3">
                                    <b-input
                                        :placeholder="$t('Type to search')"
                                        class="form-control search-input"
                                        type="text"
                                        v-model="search"
                                        v-on:change="getUsers"
                                        aria-describedby="input-search"
                                    />
                                    <div
                                        class="input-group-append"
                                        role="button"
                                    >
                                        <span
                                            class="input-group-text"
                                            id="input-search"
                                            ><i
                                                class="fas fa-search search-icon"
                                        /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <loading-animation
                            :active.sync="loading"
                            :is-full-page="false"
                            :opacity="1"
                            color="#5895FF"
                        />
                        <b-table
                            :fields="[
                                {
                                    key: 'avatar',
                                    label: '',
                                    thStyle: { width: '80px' },
                                },
                                {
                                    key: 'name',
                                    label: $t('Name'),
                                },
                                {
                                    key: 'email',
                                    label: $t('E-mail'),
                                },
                                {
                                    key: 'verified',
                                    label: $t('Verification'),
                                },
                                {
                                    key: 'status',
                                    label: $t('Status'),
                                },
                                {
                                    key: 'role',
                                    label: $t('Role'),
                                },
                                {
                                    key: 'actions',
                                    label: '',
                                    class: 'text-right',
                                },
                            ]"
                            :items="userList"
                            :responsive="true"
                            striped
                            hover
                            stacked="md"
                            show-empty
                            small
                            outlined
                            table-class="mb-3"
                        >
                            <template v-slot:cell(avatar)="data">
                                <b-img
                                    :src="data.item.avatar"
                                    center
                                    rounded="circle"
                                    width="43px"
                                />
                            </template>
                            <template v-slot:cell(name)="data">
                                {{ data.item.full_name }}
                            </template>
                            <template v-slot:cell(email)="data">
                                {{ data.item.email }}
                            </template>
                            <template v-slot:cell(verified)="data">
                                <template v-if="data.item.verified">
                                    <span class="status success" />
                                    <span
                                        class="text-success text-semibold m-l-5"
                                        >{{ $t("Verified") }}</span
                                    >
                                </template>
                                <template v-else>
                                    <span class="status danger" />
                                    <span
                                        class="text-danger text-semibold m-l-5"
                                        >{{ $t("Not verified") }}</span
                                    >
                                </template>
                            </template>
                            <template v-slot:cell(status)="data">
                                <template v-if="data.item.status">
                                    <span class="status success" />
                                    <span
                                        class="text-success text-semibold m-l-5"
                                        >{{ $t("Activated") }}</span
                                    >
                                </template>
                                <template v-else>
                                    <span class="status danger" />
                                    <span
                                        class="text-danger text-semibold m-l-5"
                                        >{{ $t("Disabled") }}</span
                                    >
                                </template>
                            </template>
                            <template v-slot:cell(role)="data">
                                {{ data.item.role_details.name }}
                            </template>
                            <template v-slot:cell()="data">
                                <b-button
                                    :title="$t('Edit user')"
                                    :to="
                                        '/dashboard/admin/users/edit/' +
                                        data.item.id
                                    "
                                    class="px-2 mb-0"
                                    size="xs"
                                    type="button"
                                    v-b-tooltip.hover
                                    v-if="data.item.id !== $store.state.user.id"
                                    variant="success"
                                >
                                    <i class="mdi mdi-square-edit-outline" />
                                </b-button>
                                <b-button
                                    :title="$t('Edit my account')"
                                    :to="'/dashboard/account'"
                                    class="px-2 mb-0"
                                    size="xs"
                                    type="button"
                                    v-b-tooltip.hover
                                    v-if="data.item.id === $store.state.user.id"
                                    variant="success"
                                >
                                    <i class="mdi mdi-square-edit-outline" />
                                </b-button>
                                <b-button
                                    :title="$t('Delete user')"
                                    @click="deleteUser(data.item.id)"
                                    class="px-2 mb-0"
                                    size="xs"
                                    type="button"
                                    v-b-tooltip.hover
                                    v-if="
                                        data.item.id !== $store.state.user.id &&
                                        $store.state.user.id <= 3
                                    "
                                    variant="danger"
                                >
                                    <i class="fas fa-fw fa-trash" />
                                </b-button>
                            </template>
                            <template v-slot:empty="scope">
                                <div class="text-center my-5">
                                    <img
                                        :alt="$t('No results')"
                                        class="mb-5"
                                        src="/img/icons/robot.svg"
                                        style="max-height: 165px"
                                    />
                                    <h3 class="bold">
                                        {{ $t("No records found") }}
                                    </h3>
                                </div>
                            </template>
                            <template v-slot:emptyfiltered="scope">
                                <div class="text-center my-5">
                                    <img
                                        :alt="$t('No results')"
                                        class="mb-5"
                                        src="/img/icons/robot.svg"
                                        style="max-height: 165px"
                                    />
                                    <h3>
                                        {{
                                            $t(
                                                "No records match the entered search"
                                            )
                                        }}
                                    </h3>
                                </div>
                            </template>
                        </b-table>

                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="form-group d-inline-flex mb-0">
                                    <select
                                        class="form-control"
                                        style="width: 70px"
                                        v-model="perPage"
                                        v-on:change="getUsers"
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                    </select>
                                </div>
                                <div class="d-inline-flex ml-2">
                                    <b-pagination
                                        :per-page="perPage"
                                        :total-rows="pagination.total"
                                        @change="changePage"
                                        v-model="page"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                                <div class="float-lg-right">
                                    {{ $t("Showing page") }}
                                    {{ pagination.currentPage }} {{ $t("of") }}
                                    {{ pagination.totalPages }}
                                    {{ $t("pages in") }} {{ pagination.total }}
                                    {{ $t("records") }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <router-view />
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "Users",
    metaInfo() {
        return {
            title: this.$i18n.t("Users"),
        };
    },
    data() {
        return {
            page: 1,
            search: "",
            perPage: 10,
            loading: true,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            userList: [],
        };
    },
    mounted() {
        this.getUsers();
    },
    methods: {
        // Change the page
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getUsers();
            }
        },
        // Get users list
        getUsers() {
            this.loading = true;
            axios
                .get("api/dashboard/users", {
                    params: {
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                    },
                })
                .then((response) => {
                    this.userList = response.data.data;
                    this.pagination = response.data.pagination;
                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getUsers();
                    } else {
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // Delete user
        deleteUser(user) {
            swal.fire({
                title: this.$t("Are you sure?"),
                text: this.$t(
                    "Removing this user will cause you to lose access and all your data will be removed from the database"
                ),
                showCancelButton: true,
                cancelButtonText: this.$t("Cancel"),
                confirmButtonText: this.$t("Delete"),
                icon: "warning",
            }).then((value) => {
                if (value) {
                    this.loading = true;
                    axios
                        .delete("api/dashboard/users/" + user)
                        .then((response) => {
                            this.getUsers();
                            this.$snack.success({
                                button: false,
                                text: response.data.data.message,
                            });
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        },
    },
};
</script>
